import React from 'react';
import { Input as AntdInput } from 'antd';
import type { InputProps as AntdInputProps } from 'antd';

export interface InputProps extends Omit<AntdInputProps, 'size'> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
  size?: 'small' | 'middle' | 'large';
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  fullWidth = false,
  size = 'large',
  className = '',
  id,
  ...props
}) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label
          htmlFor={inputId}
          className={`block mb-1 text-sm font-medium ${error ? 'text-red-500' : 'text-gray-700'}`}
        >
          {label}
        </label>
      )}

      <AntdInput
        id={inputId}
        size={size}
        status={error ? 'error' : undefined}
        prefix={leftIcon}
        suffix={rightIcon}
        className={className}
        {...props}
      />

      {(error || helperText) && (
        <div className={`mt-1 text-xs ${error ? 'text-red-500' : 'text-gray-500'}`}>
          {error || helperText}
        </div>
      )}
    </div>
  );
};

export default Input;
